import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import QuoteForm from './pages/QuoteForm';
import History from './pages/History';
import OrganizationChart from './pages/Organization';
import Location from './pages/Location';
import Certifications from './pages/Certifications';
import Harness from './pages/Harness';
import ControlBox from './pages/ControlBox';
import Manufacturing from './pages/Manufacturing';

const App = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-slate-50 font-sans text-slate-900">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/quote" element={<QuoteForm />} />
            <Route path="/history" element={<History />} />
            <Route path="/organization" element={<OrganizationChart />} />
            <Route path="/location" element={<Location />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/harness" element={<Harness />} />
            <Route path="/controlbox" element={<ControlBox />} />
            <Route path="/manufacturing" element={<Manufacturing />} />
          </Routes>
        </main>
        <Footer />

        {/* Floating Action Buttons */}
        <div className="fixed right-6 bottom-6 flex flex-col gap-4 z-40">
          {/* Quote Button */}
          <Link
            to="/quote"
            className="w-14 h-14 flex flex-col items-center justify-center bg-accent hover:bg-accent-hover text-white rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
            title="견적문의"
          >
            <span className="text-[10px] font-bold">견적</span>
            <span className="text-[10px] font-bold">문의</span>
          </Link>

          {/* Scroll Top Button */}
          <button
            onClick={scrollToTop}
            className={`w-14 h-14 flex items-center justify-center bg-primary hover:bg-primary-light text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}
            title="페이지 상단으로"
          >
            <ArrowUp size={24} />
          </button>
        </div>
      </div>
    </Router>
  );
};

export default App;